
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.21.1
 * Query Engine version: bf0e5e8a04cada8225617067eaa03d041e2bba36
 */
Prisma.prismaVersion = {
  client: "5.21.1",
  engine: "bf0e5e8a04cada8225617067eaa03d041e2bba36"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TeacherScalarFieldEnum = {
  id: 'id',
  clerkUserId: 'clerkUserId',
  email: 'email',
  timezone: 'timezone',
  name: 'name',
  imageUrl: 'imageUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  calendarSyncedAt: 'calendarSyncedAt',
  googleCalendarId: 'googleCalendarId',
  googleOAuth: 'googleOAuth',
  postmarkServerId: 'postmarkServerId',
  postmarkApiToken: 'postmarkApiToken',
  stripeCustomerId: 'stripeCustomerId',
  subscriptionStatus: 'subscriptionStatus',
  maxAccounts: 'maxAccounts',
  showFirstTimeLogin: 'showFirstTimeLogin',
  calendlyEmail: 'calendlyEmail',
  calendlyAccessToken: 'calendlyAccessToken',
  calendlySchedulingUrl: 'calendlySchedulingUrl',
  calendlyRefreshToken: 'calendlyRefreshToken',
  calendlyOrganizationUri: 'calendlyOrganizationUri',
  calendlyUserUri: 'calendlyUserUri',
  calendlyAccessTokenExpiresAt: 'calendlyAccessTokenExpiresAt',
  zoomAccessToken: 'zoomAccessToken',
  zoomRefreshToken: 'zoomRefreshToken',
  zoomEmail: 'zoomEmail',
  zoomUserId: 'zoomUserId',
  zoomPersonalMeetingLink: 'zoomPersonalMeetingLink',
  stripeAccountId: 'stripeAccountId',
  stripeCreatedAt: 'stripeCreatedAt'
};

exports.Prisma.CalendlyEventTypeScalarFieldEnum = {
  id: 'id',
  teacherId: 'teacherId',
  calendlyUri: 'calendlyUri',
  name: 'name',
  schedulingUrl: 'schedulingUrl',
  color: 'color',
  description: 'description',
  enabled: 'enabled',
  durationMinutes: 'durationMinutes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  subject: 'subject',
  body: 'body',
  senderEmail: 'senderEmail',
  sentAt: 'sentAt',
  teacherId: 'teacherId'
};

exports.Prisma.RecipientScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  messageId: 'messageId'
};

exports.Prisma.SettingsScalarFieldEnum = {
  id: 'id',
  paypal: 'paypal',
  venmo: 'venmo',
  zelle: 'zelle',
  calendarInitialDisplayTime: 'calendarInitialDisplayTime',
  calendarShowWeekends: 'calendarShowWeekends',
  teacherId: 'teacherId',
  autoInvoice: 'autoInvoice',
  autoInvoiceBalanceForward: 'autoInvoiceBalanceForward',
  autoInvoiceBillingCycleStartDate: 'autoInvoiceBillingCycleStartDate',
  autoInvoiceDaysAfterDueDate: 'autoInvoiceDaysAfterDueDate',
  autoInvoiceFrequency: 'autoInvoiceFrequency',
  autoInvoicePaymentType: 'autoInvoicePaymentType',
  calendarInitialEndDisplayTime: 'calendarInitialEndDisplayTime',
  autoInvoiceStartTime: 'autoInvoiceStartTime',
  autoInvoiceDateTime: 'autoInvoiceDateTime'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  primaryContactFirstName: 'primaryContactFirstName',
  primaryContactLastName: 'primaryContactLastName',
  primaryContactEmailAddress: 'primaryContactEmailAddress',
  primaryContactPhoneNumber: 'primaryContactPhoneNumber',
  secondaryContactFirstName: 'secondaryContactFirstName',
  secondaryContactLastName: 'secondaryContactLastName',
  secondaryContactEmailAddress: 'secondaryContactEmailAddress',
  secondaryContactPhoneNumber: 'secondaryContactPhoneNumber',
  teacherId: 'teacherId',
  autoInvoicingEnabled: 'autoInvoicingEnabled',
  studentPortalEnabled: 'studentPortalEnabled',
  studentPortalPinKey: 'studentPortalPinKey'
};

exports.Prisma.StudentScalarFieldEnum = {
  studentId: 'studentId',
  firstName: 'firstName',
  lastName: 'lastName',
  studentPhoneNumber: 'studentPhoneNumber',
  studentEmailAddress: 'studentEmailAddress',
  calendlyInviteeUri: 'calendlyInviteeUri',
  pricePerLesson: 'pricePerLesson',
  lessonLength: 'lessonLength',
  teacherId: 'teacherId',
  lastUpdated: 'lastUpdated',
  createdAt: 'createdAt',
  accountId: 'accountId',
  status: 'status'
};

exports.Prisma.StudentGroupScalarFieldEnum = {
  studentId: 'studentId',
  groupId: 'groupId'
};

exports.Prisma.GroupScalarFieldEnum = {
  groupId: 'groupId',
  groupName: 'groupName',
  groupAddress: 'groupAddress',
  groupAddressLat: 'groupAddressLat',
  groupAddressLng: 'groupAddressLng',
  groupNotes: 'groupNotes',
  groupColor: 'groupColor',
  teacherId: 'teacherId',
  createdAt: 'createdAt'
};

exports.Prisma.LessonScalarFieldEnum = {
  lessonId: 'lessonId',
  dirty: 'dirty',
  googleEventId: 'googleEventId',
  text: 'text',
  seriesId: 'seriesId',
  calendlyEventUri: 'calendlyEventUri',
  source: 'source',
  amount: 'amount',
  attendance: 'attendance',
  originalScheduledDate: 'originalScheduledDate',
  originalScheduledEndDate: 'originalScheduledEndDate',
  scheduledDate: 'scheduledDate',
  scheduledEndDate: 'scheduledEndDate',
  teacherId: 'teacherId',
  frequency: 'frequency',
  studentId: 'studentId',
  createdAt: 'createdAt',
  lastUpdated: 'lastUpdated',
  timezone: 'timezone',
  googleEventHtmlLink: 'googleEventHtmlLink',
  conferenceLink: 'conferenceLink',
  conferenceLinkType: 'conferenceLinkType'
};

exports.Prisma.EventScalarFieldEnum = {
  eventId: 'eventId',
  title: 'title',
  amount: 'amount',
  paid: 'paid',
  teacherId: 'teacherId',
  googleEventId: 'googleEventId',
  eventColor: 'eventColor',
  scheduledDate: 'scheduledDate',
  scheduledEndDate: 'scheduledEndDate',
  createdAt: 'createdAt',
  lastUpdated: 'lastUpdated',
  googleEventHtmlLink: 'googleEventHtmlLink'
};

exports.Prisma.NoteScalarFieldEnum = {
  noteId: 'noteId',
  note: 'note',
  createdAt: 'createdAt',
  lastUpdated: 'lastUpdated',
  studentId: 'studentId',
  lessonId: 'lessonId'
};

exports.Prisma.LeadScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  usagePlan: 'usagePlan',
  problemToSolve: 'problemToSolve',
  createdAt: 'createdAt'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  invoiceId: 'invoiceId',
  createdAt: 'createdAt',
  invoiceStatus: 'invoiceStatus',
  invoiceDate: 'invoiceDate',
  invoiceDueDate: 'invoiceDueDate',
  invoiceStartDate: 'invoiceStartDate',
  invoiceEndDate: 'invoiceEndDate',
  invoiceAmount: 'invoiceAmount',
  unpaidBalance: 'unpaidBalance',
  pdfFileName: 'pdfFileName',
  notes: 'notes',
  sent: 'sent',
  teacherId: 'teacherId',
  accountId: 'accountId',
  invoiceSendDate: 'invoiceSendDate',
  invoiceSentAt: 'invoiceSentAt'
};

exports.Prisma.ExpenseScalarFieldEnum = {
  transactionId: 'transactionId',
  transactionDate: 'transactionDate',
  description: 'description',
  amount: 'amount',
  type: 'type',
  expenseType: 'expenseType',
  destination: 'destination',
  distance: 'distance',
  vehicle: 'vehicle',
  expenseSeriesId: 'expenseSeriesId',
  expenseFrequency: 'expenseFrequency',
  teacherId: 'teacherId',
  createdAt: 'createdAt',
  lastUpdated: 'lastUpdated'
};

exports.Prisma.DocumentScalarFieldEnum = {
  id: 'id',
  file: 'file',
  size: 'size',
  teacherId: 'teacherId',
  createdAt: 'createdAt'
};

exports.Prisma.TransactionScalarFieldEnum = {
  transactionId: 'transactionId',
  transactionDate: 'transactionDate',
  description: 'description',
  amount: 'amount',
  type: 'type',
  accountId: 'accountId',
  expenseType: 'expenseType',
  destination: 'destination',
  distance: 'distance',
  vehicle: 'vehicle',
  expenseSeriesId: 'expenseSeriesId',
  expenseFrequency: 'expenseFrequency',
  lessonId: 'lessonId',
  balance: 'balance',
  teacherId: 'teacherId',
  createdAt: 'createdAt',
  lastUpdated: 'lastUpdated'
};

exports.Prisma.EmailTemplateScalarFieldEnum = {
  id: 'id',
  teacherId: 'teacherId',
  type: 'type',
  subject: 'subject',
  body: 'body',
  isCustom: 'isCustom',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DefaultEmailTemplateScalarFieldEnum = {
  id: 'id',
  type: 'type',
  subject: 'subject',
  body: 'body',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  INACTIVE: 'INACTIVE',
  TRIAL: 'TRIAL',
  CANCELLED: 'CANCELLED'
};

exports.AutoInvoiceFrequency = exports.$Enums.AutoInvoiceFrequency = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY'
};

exports.AutoInvoicePaymentType = exports.$Enums.AutoInvoicePaymentType = {
  PREPAID: 'PREPAID',
  POSTPAID: 'POSTPAID'
};

exports.StudentStatus = exports.$Enums.StudentStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

exports.LessonSource = exports.$Enums.LessonSource = {
  CALENDLY: 'CALENDLY'
};

exports.AttendanceType = exports.$Enums.AttendanceType = {
  UNRECORDED: 'UNRECORDED',
  PRESENT: 'PRESENT',
  ABSENT_BILLABLE: 'ABSENT_BILLABLE',
  ABSENT_NOT_BILLABLE: 'ABSENT_NOT_BILLABLE',
  CANCELLED: 'CANCELLED'
};

exports.RepeatOptions = exports.$Enums.RepeatOptions = {
  DOES_NOT_REPEAT: 'DOES_NOT_REPEAT',
  REPEATS_WEEKLY: 'REPEATS_WEEKLY',
  REPEATS_SEMIMONTHLY: 'REPEATS_SEMIMONTHLY',
  REPEATS_MONTHLY: 'REPEATS_MONTHLY'
};

exports.ConferenceLinkType = exports.$Enums.ConferenceLinkType = {
  GOOGLE_MEET: 'GOOGLE_MEET',
  ZOOM: 'ZOOM',
  MICROSOFT_TEAMS: 'MICROSOFT_TEAMS'
};

exports.InvoiceStatus = exports.$Enums.InvoiceStatus = {
  UNPAID: 'UNPAID',
  OVERDUE: 'OVERDUE',
  PAID: 'PAID',
  PARTIAL_PAID: 'PARTIAL_PAID',
  VOID: 'VOID',
  SENT: 'SENT',
  SEND_FAILED: 'SEND_FAILED'
};

exports.TransactionType = exports.$Enums.TransactionType = {
  CHARGE: 'CHARGE',
  PAYMENT: 'PAYMENT',
  DISCOUNT: 'DISCOUNT',
  REFUND: 'REFUND',
  EXPENSE: 'EXPENSE'
};

exports.ExpenseType = exports.$Enums.ExpenseType = {
  ADVERTISING: 'ADVERTISING',
  VEHICLE: 'VEHICLE',
  MILEAGE: 'MILEAGE',
  COMMISSIONS_AND_FEES: 'COMMISSIONS_AND_FEES',
  INSURANCE: 'INSURANCE',
  OFFICE: 'OFFICE',
  RENT_OR_LEASE: 'RENT_OR_LEASE',
  REPAIRS_AND_MAINTENANCE: 'REPAIRS_AND_MAINTENANCE',
  SUPPLIES: 'SUPPLIES',
  TAXES_AND_LICENSES: 'TAXES_AND_LICENSES',
  TRAVEL: 'TRAVEL',
  MEALS: 'MEALS',
  UTILITIES: 'UTILITIES',
  OTHER: 'OTHER'
};

exports.ExpenseRepeatOptions = exports.$Enums.ExpenseRepeatOptions = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY'
};

exports.EmailTemplateType = exports.$Enums.EmailTemplateType = {
  TEMPLATE_AUTO_INVOICE: 'TEMPLATE_AUTO_INVOICE',
  TEMPLATE_PAYMENT_RECEIVED: 'TEMPLATE_PAYMENT_RECEIVED',
  TEMPLATE_INVOICE_REMINDER: 'TEMPLATE_INVOICE_REMINDER'
};

exports.Prisma.ModelName = {
  Teacher: 'Teacher',
  CalendlyEventType: 'CalendlyEventType',
  Message: 'Message',
  Recipient: 'Recipient',
  Settings: 'Settings',
  Account: 'Account',
  Student: 'Student',
  StudentGroup: 'StudentGroup',
  Group: 'Group',
  Lesson: 'Lesson',
  Event: 'Event',
  Note: 'Note',
  Lead: 'Lead',
  Invoice: 'Invoice',
  Expense: 'Expense',
  Document: 'Document',
  Transaction: 'Transaction',
  EmailTemplate: 'EmailTemplate',
  DefaultEmailTemplate: 'DefaultEmailTemplate'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
